module.exports = __webpack_public_path__ + "static/product2_3-6bb8a81bacce1877c9d778c384e070a6.jpg";